import { VehicleService } from "./../../vehicle/models/vehicle.service";
import { VehicleModel } from "./../../vehicle/models/vehicle.model";
import { SharedVehicleGroupService } from "./../../sharedvehiclegroup/models/sharedvehiclegroup.service";
import { CompanyService } from "./../../company/models/company.service";
import { InstanceService } from "./../../instance/models/instance.service";
import { SharedVehicleGroupModel } from "./../../sharedvehiclegroup/models/sharedvehiclegroup.model";
import { CompanyModel } from "./../../company/models/company.model";
import { InstanceModel } from "./../../instance/models/instance.model";
import {
  ReportFilterModel,
  DropdownModel
} from "./../models/report-filter.model";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import {
  ApplicationRouteURL,
  WeGoConfig,
  IKeyValueInterface,
  RoleLevel
} from "./../../shared/config";
import { AuthService } from "./../../shared/models/auth.service";
import { VehicleOccupancyService } from "./../models/vehicle-occupancy.service";
import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { ReportFilterService } from "../models/report-filter.service";

@Component({
  selector: "wego-report-filter",
  template: require('../views/report-filter.component.html'),
  providers: [
    InstanceService,
    CompanyService,
    SharedVehicleGroupService,
    VehicleService,
    ReportFilterService
  ]
})
export class ReportFilter implements OnInit {
  @Output("OnSearch") onSearch = new EventEmitter();
  @Output("OnExportPDF") onExportPDF = new EventEmitter();
  @Output("OnExportExcel") onExportExcel = new EventEmitter();
  @Output("ResetValidSearch") resetValidSearch = new EventEmitter();

  @Input("IsValidSearch") isValidSearch: boolean = false;
  @Input("ErrorModel") errorModel: IKeyValueInterface[];
  @Input("ReportName") reportName: string;

  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  model: ReportFilterModel;
  instanceList: DropdownModel[];
  companyList: DropdownModel[];
  sharedVehicleGroupList: DropdownModel[];
  vehicleList: DropdownModel[];
  apiErrorMsg: string;
  isLoader: boolean;
  roleLevel = RoleLevel;

  constructor(
    private authService: AuthService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private sharedVehicleGroupService: SharedVehicleGroupService,
    private vehicleService: VehicleService,
    private reportFilterService: ReportFilterService
  ) { }

  ngOnInit() {
    this.model = new ReportFilterModel();
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo.defaultDate = "23:59";

    this.InitReportFilter();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public InitReportFilter() {
    this.GetAllInstanceList();
  }

  public GetAllInstanceList() {
    this.instanceService.GetDropdownInstanceList(this.reportName).subscribe(
      res => {
        this.instanceList = res.data;
        if (this.instanceList && this.instanceList.length > 0) {
          if (!this.model.instanceHashId && this.instanceList.length == 1) {
            this.model.instanceHashId = this.instanceList[0].keyHash;
          }
          this.OnInstanceChange();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetAllCompanyList() {
    this.companyService
      .GetDropdownCompanyList(this.reportName, this.model.instanceHashId)
      .subscribe(
        res => {
          this.companyList = res.data;
          this.isLoader = false;

          if (this.companyList && this.companyList.length > 0) {
            // if (!this.model.companyHashId && this.companyList.length == 1) {
            //   this.model.companyHashId = this.companyList[0].keyHash;
            // } else {
            //   this.OnCompanyChange();
            //   this.GetVehicleBySVG();
            // }

            this.OnCompanyChange();
            //this.GetVehicleBySVG();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoader = false;
        }
      );
  }

  // Value should be null in case required all svg
  public GetAllSVGList() {
    this.sharedVehicleGroupService
      .GetDropdownSVGList(
        this.reportName,
        this.model.companyHashId,
        this.model.instanceHashId
      )
      .subscribe(
        res => {
          this.sharedVehicleGroupList = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetCompanyListByInstance(instanceHashId: string) {
    this.companyService.GetCompanybyInstance(instanceHashId).subscribe(
      res => {
        this.companyList = res.data;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetVehicleBySVG() {
    // instanceHashId: string, companyHashId: string, sVGHashId: string
    // let company = sVGHashId != "" ? "" : companyHashId;
    this.vehicleService
      .GetDropdownVehicleList(
        this.reportName,
        this.model.instanceHashId,
        this.model.companyHashId,
        this.model.sVGHashId
      )
      .subscribe(
        res => {
          this.vehicleList = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  // Event
  public OnInstanceChange() {
    this.isLoader = true;
    this.ResetValidSearch();
    if (this.model.instanceHashId) {
      //this.GetCompanyListByInstance(this.model.instanceHashId);
      this.GetAllCompanyList();
      this.model.companyHashId = "";
      // this.OnCompanyChange();
      // this.GetVehicleBySVG();
    } else {
      this.companyList = [];
      this.sharedVehicleGroupList = [];
      this.vehicleList = [];
      this.model.companyHashId = "";
      this.model.sVGHashId = "";
      this.model.vehicleHashId = "";
    }
  }

  public OnCompanyChange() {
    this.ResetValidSearch();
    //this.GetAllSVGList(this.model.companyHashId,this.model.instanceHashId);
    this.GetAllSVGList();
    this.model.sVGHashId = "";
    this.OnSVGChange();
  }

  public OnSVGChange() {
    this.ResetValidSearch();
    //this.GetVehicleBySVG(this.model.instanceHashId, this.model.companyHashId, this.model.sVGHashId);
    this.GetVehicleBySVG();
    this.model.vehicleHashId = "";
  }

  public OnVehicleChange() {
    this.ResetValidSearch();
  }

  public OnFromDateChange() {
    this.ResetValidSearch();
  }

  public OnToDateChange() {
    this.ResetValidSearch();
  }

  public ResetValidSearch() {
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  // Button Click

  public OnSearch($event: any) {
    this.onSearch.emit({ model: this.model });
  }

  public OnExportPDF($event: any) {
    this.onExportPDF.emit({ model: this.model });
  }

  public OnExportExcel($event: any) {
    this.onExportExcel.emit({ model: this.model });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/components/report-filter.component.ts